import getStore from '../store/store';
import { findMeetingTimesConstants } from '../constants';
import { TimeSuggestionsRequestState } from '../store/schema/TimeSuggestionsRequestState';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

export default function getNumberOfTimeSuggestionsToDisplay() {
    const { timeSuggestions, timeSuggestionsRequestState, calendarComponent } = getStore();
    let maxCandidates = 0;
    if (timeSuggestionsRequestState == TimeSuggestionsRequestState.ShowSuggestions) {
        switch (calendarComponent) {
            case CalendarComponent.CalendarFullCompose:
                maxCandidates = findMeetingTimesConstants.MAX_CANDIDATES;
                break;
            case CalendarComponent.CalendarQuickCompose:
                maxCandidates = findMeetingTimesConstants.MAX_CANDIDATES_QUICK_COMPOSE;
                break;
            case CalendarComponent.MyDayPanelCompose:
            default:
                maxCandidates = findMeetingTimesConstants.MAX_CANDIDATES_TIMEPANEL;
                break;
        }
        const timeSuggestionsLength = timeSuggestions?.MeetingTimeSuggestions?.length ?? 0;
        return timeSuggestionsLength <= maxCandidates ? timeSuggestionsLength : maxCandidates;
    }
    return maxCandidates;
}
